import { useState, useRef, useEffect } from 'react';
import styles from './HeroSection.module.css';

const WORDS = ['보이지', '않는', '이들에게', '조명을'];
const DEFAULT_WORD_IDX = 3; // '조명을'

function HeroTitle({ onWordHover }) {
  const [hoveredIdx, setHoveredIdx] = useState(null);
  const wordRefs = useRef([]);
  const titleRef = useRef(null);
  const onWordHoverRef = useRef(onWordHover);
  onWordHoverRef.current = onWordHover;

  function getPos(idx) {
    const el = wordRefs.current[idx];
    const section = titleRef.current?.closest('section');
    if (!el || !section) return null;
    const wordRect = el.getBoundingClientRect();
    const sectionRect = section.getBoundingClientRect();
    return {
      x: wordRect.left - sectionRect.left + wordRect.width / 2,
      y: wordRect.top - sectionRect.top,
    };
  }

  // 마운트 후 + 화면 리사이즈 시 기본 위치(조명을) 재계산
  useEffect(() => {
    function updatePos() {
      const pos = getPos(DEFAULT_WORD_IDX);
      if (pos) onWordHoverRef.current?.({ idx: DEFAULT_WORD_IDX, ...pos });
    }
    const raf = requestAnimationFrame(updatePos);
    window.addEventListener('resize', updatePos);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('resize', updatePos);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function handleMouseEnter(idx) {
    setHoveredIdx(idx);
    const pos = getPos(idx);
    if (pos) onWordHoverRef.current?.({ idx, ...pos });
  }

  function handleMouseLeave() {
    setHoveredIdx(null);
    const pos = getPos(DEFAULT_WORD_IDX);
    if (pos) onWordHoverRef.current?.({ idx: DEFAULT_WORD_IDX, ...pos });
  }

  return (
    <h1 ref={titleRef} className={styles.heroTitle} onMouseLeave={handleMouseLeave}>
      {WORDS.map((word, idx) => {
        const activeIdx = hoveredIdx ?? DEFAULT_WORD_IDX;
        const dist = Math.abs(idx - activeIdx);
        const brightness = dist === 0 ? 1 : dist === 1 ? 0.45 : 0.18;
        const isActive = dist === 0;

        return (
          <span key={word} style={{ display: 'inline' }}>
            {idx > 0 && ' '}
            <span
              ref={el => { wordRefs.current[idx] = el; }}
              className={styles.heroWord}
              style={{
                color: `rgba(255,255,255,${brightness})`,
                transition: 'color 0.15s ease',
                textShadow: isActive ? '0px 0px 40px rgba(255,255,255,0.57)' : 'none',
              }}
              onMouseEnter={() => handleMouseEnter(idx)}
            >
              {word}
            </span>
          </span>
        );
      })}
    </h1>
  );
}

export default HeroTitle;
